import { jsxs as r, jsx as l } from "react/jsx-runtime";
const n = ({
  size: i = 26,
  color: t = "currentColor",
  titleAccess: h,
  variant: c = "default",
  ...o
}) => {
  let e;
  return c === "hover" ? e = "#b2b3b2" : c === "active" && (e = "#292b29"), /* @__PURE__ */ r(
    "svg",
    {
      "aria-label": h,
      width: i,
      height: i,
      viewBox: "0 0 26 26",
      fill: "none",
      ...o,
      children: [
        /* @__PURE__ */ r("g", { clipPath: "url(#clip0_8187_3634)", children: [
          /* @__PURE__ */ l("circle", { cx: "13.1133", cy: "13", r: "10", fill: t }),
          e && /* @__PURE__ */ l("circle", { cx: "13", cy: "13", r: "12.5", stroke: e })
        ] }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_8187_3634", children: /* @__PURE__ */ l("rect", { width: "26", height: "26", fill: "white" }) }) })
      ]
    }
  );
};
export {
  n as FlavorIcon
};
